import { lightTrails, parallel, pause, sequence } from 'light-trails';
import { debounce, isEqual } from 'lodash';
import { createContext } from 'react';
const STEP_ADD_DEBOUNCE = 700;
export const TimelineContext = createContext({});
export class Timeline {
  constructor() {
    this.steps = [];
    this.line = void 0;
    this.onRegisterCB = void 0;
    this.onUpdateCB = void 0;
    this.addStepDone = debounce(() => {
      this.createLine();
      this.onRegisterCB && this.onRegisterCB();
      this.runOnUpdateCB();
    }, STEP_ADD_DEBOUNCE);

    this.handleUpdate = () => {
      if (!this.line || !this.onUpdateCB) return;
      const currentTime = this.getCurrentTime();
      this.saveLastTime(currentTime);
      this.runOnUpdateCB();
    };

    this.saveLastTime = debounce(time => {
      localStorage.setItem('phenomenon:last-time', time.toString());
    }, 100);
  }

  addStep(step) {
    this.steps.push(step);
    this.addStepDone();
  }

  onRegister(cb) {
    this.onRegisterCB = cb;
  }

  onUpdate(cb) {
    this.onUpdateCB = cb;
  }

  seek(seconds) {
    this.pause();
    this.line && this.line.seek(seconds);
  }

  seekByPercent(percent) {
    if (!this.line) return;
    const pos = percent * this.line.total;
    this.seek(pos);
  }

  pause() {
    this.line && this.line.pause();
  }

  next() {
    if (!this.line) return; // if (this.line.isActive()) {
    //     this.turboMode()
    // }

    this.line.play();
  }

  back() {
    if (!this.line) return;

    const _this$line$getStatus = this.line.getStatus(),
          currentTime = _this$line$getStatus.currentTime;

    this.line.seek(currentTime - 1000);
    this.line.play(); // if (this.line.isActive()) {
    //     this.turboMode()
    // }
    // this.line.reverse()
  } // private turboTimer: any
  // private turboMode() {
  //     if (!this.line) return
  //     this.line.timeScale(5)
  //     clearTimeout(this.turboTimer)
  //     this.turboTimer = setTimeout(() => {
  //         this.line!.timeScale(1)
  //     }, 1000)
  // }


  getDuration() {
    return this.line && this.line.total;
  }

  getCurrentTime() {
    return this.line && this.line.getStatus().currentTime;
  }

  runOnUpdateCB() {
    if (!this.onUpdateCB) return;
    this.onUpdateCB(this.getCurrentTime(), this.getDuration());
  }

  getLastTime() {
    const lastTime = localStorage.getItem('phenomenon:last-time');
    if (!lastTime) return 0;
    return Number.parseFloat(lastTime) || 0;
  }

  createLine() {
    this.steps.sort(sortSteps);
    const frames = sequence(this.getGroupedSteps().flatMap(group => [parallel(group.map(step => step.getStepFrames())), pause()]));
    this.line = lightTrails(frames, {
      onUpdate: () => this.handleUpdate()
    });
    this.line.prepare();
    this.line.seek(this.getLastTime()); // this.line.play()  // Seeks before pause() TODO?
  }

  getGroupedSteps() {
    const groupedSteps = [];

    for (let i = 0; i < this.steps.length; i++) {
      var _step$options;

      const step = this.steps[i];
      const lastGroup = groupedSteps[groupedSteps.length - 1];

      if (lastGroup && (((_step$options = step.options) === null || _step$options === void 0 ? void 0 : _step$options.animateWithNext) || isEqual(step.id, lastGroup[0].id))) {
        lastGroup.push(step);
      } else {
        groupedSteps.push([step]);
      }
    }

    return groupedSteps;
  }

}

const sortSteps = (a, b) => {
  const aLen = a.id.length;
  const bLen = b.id.length;
  const minLen = Math.min(aLen, bLen);

  for (let n = 0; n < minLen; n++) {
    const an = norm(a.id[n]);
    const bn = norm(b.id[n]);
    if (an < bn) return -1;
    if (an > bn) return +1;
  }

  return aLen - bLen;
};

const norm = a => Math.abs(a) + (a < 0 ? 0.5 : 0);